import { Button } from '@storeblocks/button';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

interface Props {
  onClick: () => void;
}

export const RemoveDualCitizenshipButton: FC<Props> = ({ onClick }) => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <div>
      <Button
        variant="tertiary"
        iconLeft="close"
        onClick={onClick}
        data-trackid={getTrackId(
          'remove-dual-citizenship',
          TrackingElement.Button,
        )}
      >
        {texts.orders.signatureRight.pep.citizenship.removeDual}
      </Button>
    </div>
  );
};
